import { TreeNodeData } from '@estimate/treetable/models/tree-node-data.model';
import { TreeNode } from 'primeng/api';

export class TreeNodeHelper {

  public static recurseTree<T = unknown>(
    node: TreeNode<TreeNodeData<T>>,
    onNode: (n: TreeNode<TreeNodeData<T>>) => void,
    onNodeLeaf: (n: TreeNode<TreeNodeData<T>>) => void = undefined
  ) {
    onNode(node);

    if (node.children && node.children.length > 0) {
      node.children?.forEach(childNode => {
        TreeNodeHelper.recurseTree(childNode, onNode); // recursive call
      });
    } else if (onNodeLeaf) {
      onNodeLeaf(node);
    }
  }

  public static count<T = unknown>(tree: TreeNode<TreeNodeData<T>>){
    let records: number;
    let projectLength = tree.children.length;
    let level1Length: number;
    for (let level1Children of tree.children) {
      level1Length = level1Children.children.length;
      let level2Length: number;
      for (let level2Children of level1Children.children) {
        level2Length = level2Children.children.length;
        let level3Length: number;
        for (let level3Children of level2Children.children) {
          level3Length = level3Children.children.length;
          records =
            projectLength + level1Length * projectLength + level2Length * level1Length + level3Length * level2Length;
        }
      }
    }
    return 1 + records;
  }

}
